// Вспомогательная функция для получения отображаемого имени
export const getDisplayName = (user) => {
  const firstName = user.first_name?.String || user.first_name || '';
  const lastName = user.last_name?.String || user.last_name || '';
  const username = user.username?.String || user.username || '';
  const phone = user.phone?.String || user.phone || '';
  const email = user.email?.String || user.email || '';
  
  if (firstName || lastName) {
    return `${firstName} ${lastName}`.trim();
  }
  if (username) return username;
  if (phone) return phone;
  if (email) return email;
  return `User ${user.id}`;
};
// Получение инициалов для аватара-заглушки
export const getInitials = (name) => {
  if (!name || typeof name !== 'string') return '?';
  const parts = name.trim().split(' ');
  if (parts.length >= 2) {
      const first = parts[0]?.[0] || '';
      const last = parts[1]?.[0] || '';
      return (first + last).toUpperCase();
  }
  if (parts[0] && parts[0].length > 0) {
      return parts[0].substring(0, 2).toUpperCase();
  }
  return '?';
};
// Генерация цвета фона для аватара-заглушки
export const getAvatarColor = (id) => {    
  const hue = (id * 137) % 360;   
  return `hsl(${hue}, 60%, 40%)`;
};
// Генерация цвета Usera
export const getUserColor = (userId) => {
  // Используем ID для генерации оттенка (0-360)
  const hue = (userId * 137) % 360; // Простое число 137 даёт хорошее распределение
  // Насыщенность 70%, яркость 65% (хорошо видно на тёмном фоне)
  return `hsl(${hue}, 70%, 65%)`;
};
// Очистка user объекта от обёрток sql.NullString
export const cleanUser = (user) => {
   
   const getString = (value) => {
        if (!value) return '';
        if (typeof value === 'string') return value;
        if (value.String !== undefined) return value.String;
        if (value.Valid !== undefined && value.Valid === false) return '';
        return String(value);
    };
    
    return {
        id: user.id,
        username: getString(user.username),
        phone: getString(user.phone),
        email: getString(user.email),
        firstName: getString(user.first_name),
        lastName: getString(user.last_name),
        avatar_url: getString(user.avatar_url),
        displayName: getDisplayName(user),
    };
};
 // Получение ID другого пользователя в приватном чате
  export const getOtherUserId = (chatId, currentUserId) => {
      // chatId имеет формат private_1_2
      const parts = chatId.split('_');
      if (parts.length === 3) {
          const id1 = parseInt(parts[1]);
          const id2 = parseInt(parts[2]);
          return id1 === currentUserId?.id ? id2 : id1;
      }
      return null;
  };
  // ID приватного чата из двух пользователей
export const getPrivateChatId = (userId1, userId2) => {
    const minId = Math.min(userId1, userId2);
    const maxId = Math.max(userId1, userId2);
    return `private_${minId}_${maxId}`;
};